module.exports = __webpack_public_path__ + "media/entities/2213-ce0541c1.png";